import { Image } from '@chakra-ui/image';
import { Box } from '@chakra-ui/layout';
import React, { ReactElement } from 'react';

import playIcon from '../../../../../../assets/icons/icon_play.svg';
import * as styled from './video-thumbnail.styled';

type VideoThumbnailProps = {
background?: string
title?: string | ReactElement
onClick?: () => void
};

export const VideoThumbnail = ({
    background,
    title,
    onClick
}: VideoThumbnailProps) => {
    return (
        <styled.wrapper>
            <styled.container
                backgroundImage={background}
                onClick={onClick}
            >
                <Image src={playIcon} />
                <Box ml={'5px'}>{title}</Box>
            </styled.container>
        </styled.wrapper>
    );
};
